import { render, staticRenderFns } from "./WarningIconWithTooltip.vue?vue&type=template&id=5f16fd17&scoped=true"
import script from "./WarningIconWithTooltip.vue?vue&type=script&lang=js"
export * from "./WarningIconWithTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f16fd17",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
